import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=df9008dc&scoped=true&"
import script from "./Address.vue?vue&type=script&lang=ts&"
export * from "./Address.vue?vue&type=script&lang=ts&"
import style0 from "./Address.vue?vue&type=style&index=0&id=df9008dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9008dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
